var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CabeceraModal",
        { attrs: { titulo: _vm.titulo }, on: { cerrar: _vm.handleCerrar } },
        [
          _vm._t("default"),
          _c("GuardarCambiosButton", {
            attrs: { disabled: _vm.isGuardarDisabled },
            on: { click: _vm.handleGuardar }
          })
        ],
        2
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionGuardar,
          titulo: _vm.tituloEliminar,
          mensaje: _vm.mensajeConfirmacionInactivo,
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleConfirmacionGuardar }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogNoGuardaInactivo,
          titulo: _vm.tituloEliminar,
          mensaje: _vm.mensajeGuardarInactivo,
          mostrarBoton: false,
          textoBtnSi: "Aceptar"
        },
        on: { modalConfirmationEmit: _vm.handleIncativeGuardar }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.showConfirmacionCerrar,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleConfirmarCerrar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }